import { render, staticRenderFns } from "./CarouselVideo.vue?vue&type=template&id=379ccb19&scoped=true&"
import script from "./CarouselVideo.vue?vue&type=script&lang=js&"
export * from "./CarouselVideo.vue?vue&type=script&lang=js&"
import style0 from "./CarouselVideo.vue?vue&type=style&index=0&id=379ccb19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379ccb19",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
